"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const constants_1 = require("../../constants");
const helpers_1 = require("../../helpers");
const payloads_1 = require("../../payloads");
const constants_2 = require("../../payloads/constants");
const sendVideoCallNotification = ({ signer, chainId, pgpPrivateKey }, { recipientAddress, senderAddress, chatId, signalData = null, status, env = constants_1.default.ENV.PROD, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const videoData = {
            recipientAddress,
            senderAddress,
            chatId,
            signalData,
            status,
        };
        console.log('sendVideoCallNotification', 'videoData', videoData);
        const senderAddressInCaip = (0, helpers_1.getCAIPWithChainId)(senderAddress, chainId);
        const recipientAddressInCaip = (0, helpers_1.getCAIPWithChainId)(recipientAddress, chainId);
        const notificationText = `Video Call from ${senderAddress}`;
        yield (0, payloads_1.sendNotification)({
            senderType: 1,
            signer,
            pgpPrivateKey,
            chatId,
            type: 3,
            identityType: 2,
            notification: {
                title: notificationText,
                body: notificationText,
            },
            payload: {
                title: 'VideoCall',
                body: 'VideoCall',
                cta: '',
                img: '',
                additionalMeta: {
                    type: `${constants_2.ADDITIONAL_META_TYPE.PUSH_VIDEO}+1`,
                    data: JSON.stringify(videoData),
                }
            },
            recipients: recipientAddressInCaip,
            channel: senderAddressInCaip,
            env,
        });
    }
    catch (err) {
        console.log('Error occured while sending notification for video call', err);
    }
});
exports.default = sendVideoCallNotification;
//# sourceMappingURL=sendVideoCallNotification.js.map